export var DocType;
(function (DocType) {
    DocType["DISPLAYABLE_DATA"] = "DISPLAYABLE_DATA";
    DocType["CARD"] = "CARD";
    DocType["DATASHAPE"] = "DATASHAPE";
    DocType["QUESTIONTYPE"] = "QUESTION";
    DocType["VIEW"] = "VIEW";
    DocType["PEDAGOGY"] = "PEDAGOGY";
    DocType["CARDRECORD"] = "CARDRECORD";
    DocType["SCHEDULED_CARD"] = "SCHEDULED_CARD";
    DocType["TAG"] = "TAG";
})(DocType || (DocType = {}));
const cardHistoryPrefix = 'cardH';
export function getCardHistoryID(courseID, cardID) {
    return `${cardHistoryPrefix}-${courseID}-${cardID}`;
}
export function parseCardHistoryID(id) {
    const split = id.split('-');
    let error = '';
    error += split.length === 3 ? '' : `\n\tgiven ID has incorrect number of '-' characters`;
    error +=
        split[0] === cardHistoryPrefix ? '' : `\n\tgiven ID does not start with ${cardHistoryPrefix}`;
    if (split.length === 3 && split[0] === cardHistoryPrefix) {
        return {
            courseID: split[1],
            cardID: split[2],
        };
    }
    else {
        throw new Error('parseCardHistory Error:' + error);
    }
}
export function areQuestionRecords(h) {
    return isQuestionRecord(h.records[0]);
}
export function isQuestionRecord(c) {
    return c.userAnswer !== undefined;
}
//# sourceMappingURL=db.js.map